<template>
  <div class="basic_con">
    <Frame title="客户评级">
      <template slot="contentSlot">
        <div class="con_wrapper">
           <a-empty description="未查询到相关数据" />
        </div>
      </template>
      
      
       </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
export default {
  name: "customerGrade",
  components: {
    Frame,
  },
  data() {
    return {};
  },
  methods: {
    // btnClick() {
    //   this.$emit("fatherEvent", "foodNews");
    // },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  height:397px;
}
.con_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height:250px;
}

</style>

